import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../store'
import { Styled_Header_Page, Logo, Menu, DropdownMenu, Welcome, Logout_Btn } from '../styles/header'
import { Button_Main } from './Button'
import { theme } from '../styles/theme'
import { useAuthCheck } from '../hook'
import { Dialog } from './Dialog'
import { UserUpdateForm } from './Form'

function Header() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { checkAuth } = useAuthCheck()
  const [isExpanded, setIsExpanded] = useState(false)
  const { username, Id } = useAuth((store) => store)
  const role = useAuth((store) => store.role)
  const [isHidden, setIsHidden] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)
  const [isUpdateOpen, setIsUpdateOpen] = useState(false)

  const handleScroll = () => {
    const currentScrollY = window.scrollY
    if (currentScrollY > lastScrollY && currentScrollY > 60) {
      setIsHidden(true)
    } else {
      setIsHidden(false)
    }
    setLastScrollY(currentScrollY)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [lastScrollY])

  const linkPage = (e: React.MouseEvent<HTMLLIElement>) => {
    // HTML 요소에서 data-link 속성을 가져오기
    const target = e.target as HTMLElement
    const dataLink = target.getAttribute('data-link')
    const nextPath = dataLink === 'user' && role === 'ROLE_USER' ? 'history' : role === 'ROLE_INIT' ? 'upload' : dataLink
    if (nextPath) navigate(`/${nextPath}`)
  }

  const logout = () => {
    Cookies.remove('RT')
    window.location.replace('/unauth/signin')
  }
  //useAuthCheck 이게 훅 조건안에서 문제라면 이거를 useAuthCheck그냥 롤을 불러와서 여기서 계산해서 비슷하게 랜더링하는걸 해보자
  return (
    <Styled_Header_Page className={isExpanded ? 'expanded' : ''} $isHidden={isHidden} onClick={linkPage}>
      <Logo data-link="user"><img src={`/logo-icon.png`} alt="TS교통안전공단 로고" data-link="user" /></Logo>
      <Menu onMouseEnter={() => setIsExpanded(true)} onMouseLeave={() => setIsExpanded(false)} $pathname={pathname.substring(1)}>
        {checkAuth('1110') && 
        <DropdownMenu>
          {checkAuth('1110') && <label data-link="user">사용자 관리</label>}
          {checkAuth('1100') && <li data-link="part">소속 관리</li>}
          {checkAuth('1110') && <li data-link="group">그룹 관리</li>}
          {checkAuth('1110') && <li data-link="activity">사용 이력</li>}
        </DropdownMenu>}
        <DropdownMenu>
          {checkAuth('1111') && <label data-link="device">단말 관리</label>}
          {checkAuth('1111') && <li data-link="upload">업로드 이력</li>}
          {checkAuth('10000') && <label data-link="upload">업로드 이력</label>}
        </DropdownMenu>
        <DropdownMenu>
          {checkAuth('1111') && <label data-link="history">운행 이력</label>}
          {checkAuth('1111') && <li data-link="history/compare">운행 통계</li>}
          {checkAuth('1000') && <li data-link="calc">계산식 설정</li>}
        </DropdownMenu>
      </Menu>
      <Welcome>
        반갑습니다&nbsp;<strong onClick={()=>setIsUpdateOpen(true)}>{username}</strong>님
      </Welcome>
      <Button_Main onClick={logout} $bgColor={theme.colors.blue} $height={'42px'}>
        로그아웃
      </Button_Main>
      <Dialog $isOpen={isUpdateOpen} onClose={() => setIsUpdateOpen(false)}>
        {isUpdateOpen && <UserUpdateForm data={Id} onClose={() => setIsUpdateOpen(false)} />}
      </Dialog>
    </Styled_Header_Page>
  )
}

export default Header
